export type TextAlign = 'left' | 'right' | 'center' | 'start' | 'end';
export type TextBaseline =
  | 'top'
  | 'hanging'
  | 'middle'
  | 'alphabetic'
  | 'ideographic'
  | 'bottom';

export interface BorderDetails {
  enabled: boolean;
  color?: string;
}

export enum LabelLayout {
  Ellipsis = 'ellipsis',
  Fallback = 'fallback',
  Inline = 'inline',
  Multi = 'multi',
  Name = 'name',
}
